import videojs from 'video.js';
import store from 'store';
const PLUGIN_NAME = 'persistTextTrackState';
const KEY = 'enableTextTrack';
videojs.registerPlugin(PLUGIN_NAME, function () {
    this.ready(function () {
        const player = this;
        player.on('loadedmetadata', function () {
            const tracks = player.textTracks();
            // 保存されている状態を復元
            const enabled = !!store.get(KEY, false); // default disabled
            for (let i = 0; i < tracks.length; i++) {
                // enable/disable first caption
                if (tracks[i].kind === 'captions') {
                    tracks[i].mode = enabled ? 'showing' : 'hidden';
                    break;
                }
            }
            // 更新された状態を保存
            tracks.addEventListener('change', function () {
                let enabled = false;
                for (let i = 0; i < tracks.length; i++) {
                    if (tracks[i].kind === 'captions' && tracks[i].mode === 'showing') {
                        enabled = true;
                        break;
                    }
                }
                store.set(KEY, enabled);
            });
        });
    });
});
export default PLUGIN_NAME;
